import React from 'react';
import { Box, Typography, Stack, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ProductInformationProps } from './types';

export const ProductInformation: React.FC<ProductInformationProps> = ({
  name,
  sku,
  ean,
  onNameChange,
  onSkuChange,
  onEanChange,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1.25,
        backgroundColor: 'background.paper',
        overflow: 'hidden',
      }}
    >
      <Box sx={{ px: 2.5, py: 1.25, borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'grey.50' }}>
        <Typography variant="subtitle2" fontWeight={600} color="text.primary">
          {t('translation.productInformationTitle')}
        </Typography>
      </Box>
      <Box sx={{ p: 2.5 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <TextField
            label={t('translation.productName')}
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            fullWidth
            required
            size="small"
          />
          <TextField
            label={t('translation.productSku')}
            value={sku}
            onChange={(e) => onSkuChange(e.target.value)}
            fullWidth
            size="small"
          />
          <TextField
            label={t('translation.productEan')}
            value={ean}
            onChange={(e) => onEanChange(e.target.value)}
            fullWidth
            size="small"
          />
        </Stack>
      </Box>
    </Box>
  );
};

